(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('States', States)
        .factory('StatesByCountry', StatesByCountry)
        .factory('StatesByZone', StatesByZone)
        .factory('StatesAll', StatesAll);

    States.$inject = ['$resource'];
    StatesByCountry.$inject = ['$resource'];
    StatesByZone.$inject = ['$resource'];
    StatesAll.$inject = ['$resource'];


    function StatesByCountry ($resource) {
        var resourceUrl =  'api/states/country/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function StatesByZone ($resource) {
        var resourceUrl =  'api/states/zone/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function States ($resource) {
        var resourceUrl =  'api/states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }


    function StatesAll ($resource) {
        var resourceUrl =  'api/states/all';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
